module.exports = __webpack_public_path__ + "static/media/smoke-car.0587109b.svg";